(() => {
  const hondaPowersports = /^(?:ATC|TRX|SXS|CBR|CBF|C\d|CA\d|F6B|SCL\d|CB\d|CMX|CRF|CR\d|CT\d|CTX|GL\d|NC\d|NPS|NSS|NVA|NT\d|NX\d|PCX|ST\d|VT|VTR|VTX|XL\d|XR\d|Z\d|VF|VFR|RVT|DN\d|ADV\d|GB\d|CL\d|SL\d|TL\d|MT\d|MB\d|NSR|NS\d|CH\d|CN\d|CX\d|FT\d|NH\d|PS\d|SH\d|SS\d|SUPER CUB|GROM|MONKEY|RUCKUS|NAVI|GOLD WING|REBEL|SHADOW|FOURTRAX|PIONEER|TALON)/i;
  const powersportsMakes = /^(?:Arctic Cat|Aprilia|Buell|Can-Am|Ducati|Harley-Davidson|Husaberg|Husqvarna|Indian|Kawasaki|KTM|Polaris|Sea-Doo|Ski-Doo|Victory|Yamaha)$/i;
  let queued = false;
  function filterWidgets() {
    queued = false;
    document.querySelectorAll('.cm_vehicle-widget').forEach(widget => {
      const selects = Array.from(widget.querySelectorAll('select.cm_select_inner-select'));
      const make = selects[1];
      const model = selects[2];
      if (make) Array.from(make.options).forEach(option => { if (powersportsMakes.test(option.text.trim())) option.remove(); });
      if (!make || !model || make.value.toLowerCase() !== 'honda') return;
      let reset = false;
      Array.from(model.options).forEach(option => {
        if (option.value && hondaPowersports.test(option.text.trim())) {
          if (option.selected) reset = true;
          option.remove();
        }
      });
      if (reset) { model.value = ''; model.dispatchEvent(new Event('change', {bubbles:true})); }
    });
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(filterWidgets); } };
  new MutationObserver(schedule).observe(document.documentElement, {childList:true,subtree:true});
  document.addEventListener('change', schedule);
  filterWidgets();
})();
